import React from 'react';
import { Box, Link, Typography } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { theme } from '../../../theme';

const PRIVACY_POLICY_URL = 'https://www.docsihealth.com/privacy-policy';

function PrivacyPolicyBanner({ physician }) {
    if (physician?.privacy_policy_accepted_at) return null;

    return (
        <Box
            sx={{
                width: '100%',
                backgroundColor: theme.palette.privacyPolicy.background,
                borderBottom: `1px solid ${theme.palette.privacyPolicy.border}`,
                py: 0.75,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 0.5,
            }}
        >
            <InfoOutlinedIcon sx={{ fontSize: '14px', color: theme.palette.privacyPolicy.accent, flexShrink: 0 }} />
            <Typography variant='normal' sx={{ fontSize: '12px', color: theme.palette.text.primary }}>
                By using the DOCSI portal, you acknowledge our{' '}
                <Link href={PRIVACY_POLICY_URL} target='_blank' rel='noopener noreferrer' sx={{ color: theme.palette.privacyPolicy.accent }}>
                    privacy policy
                </Link>
                .
            </Typography>
        </Box>
    );
}

export default PrivacyPolicyBanner;
